import { z } from 'zod';

export const meetingSlotSchema = z
  .object({
    id: z.number(),
    start_date: z.string().pipe(z.coerce.date()),
    end_date: z.string().pipe(z.coerce.date()),
  })
  .transform((raw) => {
    return {
      id: raw.id,
      startDate: raw.start_date,
      endDate: raw.end_date,
    };
  });

export type MeetingSlotEntityApi = z.input<typeof meetingSlotSchema>;
export type MeetingSlotEntity = z.infer<typeof meetingSlotSchema>;
